import { Vue, Component, Prop } from "vue-property-decorator";
import MealCard from "@/components/mealCard/mealCard.vue";

@Component({
    components: {
        MealCard
    }
})
export default class MealsCarousel extends Vue {
  @Prop() index: number;
  @Prop() items: any;
  @Prop() totalItems: number;
  @Prop() Plate: any;
  @Prop() PlateId: any;

  step = 0;
  increments = 0;
  innerStyles = {};
  plates =  [];

  next(index: any) {
    this.updateCarousel(-this.increments, index);
  }

  prev(index: any) {
    this.updateCarousel(this.increments, index);
  }

  mounted() {
    let intViewportWidth = window.innerWidth;
    if(intViewportWidth > 768) {
        this.increments = 400;
    } else {
        this.increments = 340;
    }
    
    this.plates = this.items;
    
  }

  get getPlates() {
    // Return plates sorted by count_id (ascending)
    return this.plates.sort((a, b) => {
      return a.count_id - b.count_id;
    });
  }

  updateCarousel(step, index) {

    this.step = this.step + step;

    if(this.step < this.maximumCarouselWidth()) {
        this.step = this.step + this.increments;
    }

    if(this.step > 0) this.step = 0;

    if(this.step >= this.maximumCarouselWidth()) this.innerStyles = "transform: translateX(" + this.step + "px); transform: translateX(" + this.step + "px);";
    
    
  }

  maximumCarouselWidth() {
    let intViewportWidth = window.innerWidth;

    if(this.totalItems < 3 && intViewportWidth > 768) return 0;
    if(this.totalItems == 3 && intViewportWidth > 768) return -(this.totalItems -2 ) * this.increments;
    if(this.totalItems > 3 && intViewportWidth > 768) return -(this.totalItems - 3) * this.increments;
    return -(this.totalItems - 1 ) * this.increments;

  }

}

